// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1988":"4f380a35","5411":"f215d0a1","6057":"2c1d2028","6342":"3e7a6be7","8461":"7c04c290","9449":"f54eeccc"}[chunkId] + ".chunk.css";
};